
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  
  Flits(document).on('Flits:contactUS:Loaded', function(event){  
    var data = event.detail;
    Flits.shopCountryName = 'Italy';
  });
  
  Flits(document).on('Flits:myProfile:Loaded', function(event){
//     if (!Flits("[data-flits-birthdate]").attr("data-flits-birthdate")){
      let customer_note_url = Flits.base_url+'/'+Flits.customer_id + "/get_customer_shopify_data";
      Flits.ajax({
        method: "get",
        url: customer_note_url,
        data: {
          customer_hash: Flits.customerHash, token:Flits.token
        },
      }).done(function(resp){ 
        if (resp.status) {
          console.log(resp);
          window.flits_exist_customer_note = resp.customer.note;
          if (window.flits_exist_customer_note){
            var customer_note = window.flits_exist_customer_note;
            var item = 'birthday:';
            if(customer_note.indexOf(item) != -1){
              var all_note_data = customer_note.split('\n');
              Flits.each(all_note_data,function(index_i,item_i){
                if(item_i.indexOf(item) != -1){
                  //             var item_old = item_i.replace(item_i, item);
                  var note_val = item_i.replace(item ,"").trim();
                  if(note_val){
                    Flits("[data-flits-birthdate] .flits-input").val(note_val);  
                    Flits('#flits-form-profile .flits-input[name="birthdate"]').attr("value",note_val);
                    Flits("[data-flits-birthdate]").attr("data-flits-birthdate",note_val);
                  }
                }
              });
            }  
          }
        }
      }).fail(function(resp){

      }).always(function(){});
//     }
  });
  
  // To Update Birthday in the customer note..
  
  Flits(document).on('Flits:myProfile:BeforeUpdate', function(event){

    var e_data =  event.detail.params;
    var customer_note = window.flits_exist_customer_note;
    if (customer_note === null){
      customer_note = customer_note ||  ""; 
    }
    var new_customer_note = customer_note;  
    var birthdate_val = Flits('#flits-form-profile .flits-input[name="birthdate"]').val().trim();
    if(customer_note.indexOf("birthday:") == -1){
      new_customer_note +=  "\nbirthday" + ": " + birthdate_val +"\n";
    }else{     
      var all_note_data = customer_note.split('\n');
      Flits.each(all_note_data,function(index_i,item_i){
        if(item_i.indexOf("birthday:") != -1){         
          new_customer_note = new_customer_note.replace(item_i, "birthday" + ": " + birthdate_val);
        }
      });    
    }
    if(birthdate_val){
      e_data.push({"name":"customer_note","value":new_customer_note});      
    }
  });

}(Flits));
